/** Erreur d'API portant le statut HTTP, pour distinguer 401 (déconnexion) du reste. */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Client HTTP unique. `credentials: 'include'` est indispensable : la session
 * vit dans un cookie httpOnly, jamais dans le localStorage (inaccessible au JS,
 * donc involable par XSS).
 */
export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    credentials: 'include',
    headers: {
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...init?.headers,
    },
  });

  if (!res.ok) {
    let message = `Erreur ${res.status}`;
    try {
      const body = await res.json();
      if (typeof body?.error === 'string') message = body.error;
    } catch {
      // Réponse non-JSON (proxy, coupure réseau) — on garde le message générique.
    }
    throw new ApiError(res.status, message);
  }

  return res.json() as Promise<T>;
}

// --- Types partagés avec l'API --------------------------------------------

export type SessionUser = {
  id: number;
  username: string;
  fullName: string;
  role: 'REP' | 'REP_SUPER' | 'ADMIN' | 'COMPTOIR' | 'REP_JEUX';
};

export type LineSummary = { id: number; code: string; name: string };

export type MeResponse = { user: SessionUser; lines: LineSummary[] };
